export default "__VITE_ASSET__CoerQuU4__"